import { render, staticRenderFns } from "./App_sc.vue?vue&type=template&id=0cd48936&scoped=true&"
import script from "./App_sc.vue?vue&type=script&lang=js&"
export * from "./App_sc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd48936",
  null
  
)

export default component.exports